/**
 * AccountInfoSheet
 *
 * Displays the account-area items (admin-gated Admin first, then Wallet,
 * Unlocked videos, Subscriptions, Subscribers, Likes, Watch later, Favourite
 * people) extracted from the legacy `HomeTopBarBody`. Opened from the
 * own-profile primary "Account" button on `UserDetailsPage`.
 *
 * Flutter source: lib/presentation/bottom_sheet/account_info_bottom_sheet.dart
 * (the sheet host; web omits the Settings entry — see `useAccountInfoItems`
 * docs — and surfaces the admin-gated Admin entry first, opening `AdminSheet`).
 */

import { SheetService } from '../service/SheetService';
import { AccountInfoContent } from './components/AccountInfoContent';

/**
 * Configuration for showing the Account Info sheet
 */
export interface AccountInfoSheetConfig {
  /** Optional container element, screen key string, or null */
  container?: HTMLElement | string | null;

  /** Optional screen key of the route opening this sheet */
  screenKey?: string;

  /** Force the sheet to render as a dialog instead of a bottom sheet */
  forceDialog?: boolean;
}

/**
 * Show an Account Info sheet.
 *
 * @param config - Configuration for the sheet
 * @returns Promise that resolves when the sheet is dismissed
 *
 * @example
 * await AccountInfoSheet.show({ screenKey });
 */
const show = (config: AccountInfoSheetConfig = {}): Promise<void> => {
  return new Promise((resolve) => {
    SheetService.show({
      content: <AccountInfoContent screenKey={config.screenKey} />,
      onClose: resolve,
      closeOnClickOutside: true,
      container: config.container,
      screenKey: config.screenKey,
      forceDialog: config.forceDialog,
      qaId: 'account-info',
    });
  });
};

export const AccountInfoSheet = {
  show,
};
